// extracted by mini-css-extract-plugin
module.exports = {"legalFooter":"style-module__legalFooter___rqY9d","normalLink":"style-module__normalLink___dCbbp"};